export enum Gems {
  red = 'red',
  blue = 'blue',
  yellow = 'yellow',
  green = 'green',
  purple = 'purple',
  orange = 'orange',
  wood = 'wood',
  brick = 'brick',
  slime = 'slime',
  grass = 'grass',
  apple = 'apple',
  pearl = 'pearl',
  cheese = 'cheese',
  sushi = 'sushi',
  onion = 'onion',
  pumpkin = 'pumpkin',
  honey = 'honey',
  bone = 'bone',
  coral = 'coral',
  foam = 'foam',
  scarab = 'scarab',
  yarn = 'yarn',
  tennis = 'tennis',
  football = 'football',
  golf = 'golf',
  marble = 'marble',
  vortex = 'vortex',
  paua = 'paua',
  geode = 'geode',
  star = 'star',
  pinecone = 'pinecone',
  neutral = 'neutral',
  gold = 'gold',
  silver = 'silver',
  bronze = 'bronze',
  lava = 'lava',
  ice = 'ice',
  caviar = 'caviar',
  void = 'void',
}

export type GemType = keyof typeof Gems;

export type GemAssets = {
  [type in GemType]?: any;
};

export interface IGem {
  type: GemType;
}

export type GemState = 'normal' | 'selected' | 'broken';
